/* eslint-disable max-len */
const en = {
  nav: {
    archives: "Archives",
    apropos: "About",
    vestiaire: "Wardrobe",
    journal: "Journal",
    contact: "Contact",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    openCart: "Open cart",
    cart: "Cart",
  },

  footer: {
    rights: "All rights reserved.",
    legal: "Legal notice",
  },

  cart: {
    title: "Cart",
    empty: "Your cart is silent.",
    emptySub: "Choose a piece from the wardrobe or write to us for a personalised order.",
    discoverCta: "See the wardrobe",
    sizeUnique: "One size",
    summary: "Subtotal",
    note: "Shipping and taxes calculated at checkout. Made-to-order within 3 to 4 weeks.",
    checkout: "Place order",
    redirecting: "Redirecting…",
    contactLink: "Write to the atelier",
    remove: "Remove",
  },

  product: {
    breadcrumbBack: "Wardrobe",
    sizeLabel: "Size",
    addToCart: "Add to cart",
    soonCta: "Notify me",
    soonNote: "Season 01 — coming soon to the atelier.",
    onOrder: "Order this piece",
    onOrderNote: "Available on request.",
    soldOut: "Sold out",
    statusSoon: "Soon",
    statusLabel: "Status",
    statusAvailable: "Available",
    statusOnOrder: "Made to order",
    statusSoldOut: "Sold out",
    accordionStory: "The story",
    accordionMaterials: "Care",
    accordionShipping: "Shipping & returns",
    materialsText: "Hand-wash or dry-clean recommended. Iron gently inside out. To preserve the fabric, avoid prolonged sun exposure and prefer flat drying.",
    shippingText: "Pulaar ships worldwide via DHL Express. France free, Europe €15, International €25. Estimated 2 to 3 weeks. Returns within 14 days on non-personalised pieces.",
    fabricationNote: "Made to order within 3 to 4 weeks.",
    contactLink: "Write to the atelier",
  },

  vestiaire: {
    eyebrow: "— Wardrobe",
    title: "Pieces, archives, presences.",
    subtitle: "Each Pulaar garment is numbered, dated, and archived. One piece, one memory, one trace.",
    filterAll: "All",
    filterCategory: {
      tops: "Tops",
      shirts: "Shirts",
      jackets: "Jackets",
      pants: "Trousers",
    },
    counter: "{{count}} pieces",
    empty: "No pieces in this category for now.",
  },

  checkout: {
    summaryTitle: "Your piece",
    origin: "Origin",
    fabrication: "Made in",
    size: "Size",
    quantity: "Quantity",
    total: "Total",
    paymentTitle: "Secure payment",
    paymentSubtitle: "Stripe — credit card",
    backToVestiaire: "Back to wardrobe",
    success: "Payment confirmed",
    successSub: "Your order has been recorded. A confirmation email is on its way.",
    successCta: "Continue browsing",
    error: "Something went wrong while creating the payment.",
    pieceLabel: "— Your piece",
    paymentNote: "Secure payment by Stripe. Pulaar ships within the European Economic Area, the United Kingdom, the United States, Canada, Japan and Senegal.",
    loading: "Loading payment…",
    missingKey: "Stripe publishable key missing on the server.",
    checkingPayment: "Checking payment…",
    paidTitle: "Payment confirmed.",
    paidSub: "Thank you. We are preparing your piece and will write you upon shipping. A confirmation has just been sent to your email.",
    amount: "Amount",
    backToVestiaire: "Back to wardrobe",
    pendingTitle: "Bank verification in progress.",
    pendingSub: "If the payment is confirmed, you will receive an email. For any question, write to info@pulaar.co.",
    backHome: "Back to home",
    expiredTitle: "Session expired.",
    expiredSub: "You can re-launch the order from the wardrobe.",
    noSession: "No session found.",
  },

  contact: {
    eyebrow: "— Atelier",
    title: "Write to",
    titleEm: "Pulaar.",
    subtitle: "For an availability check, a special order, a collaboration, or a question — we read every message.",
    name: "Name",
    email: "Email",
    kind: "Subject",
    kinds: {
      disponibilite: "Piece availability",
      commande: "Special order",
      collaboration: "Collaboration",
    },
    message: "Message",
    submit: "Send",
    sending: "Sending…",
    sent: "Message sent.",
    sentSub: "We'll get back to you very soon.",
    error: "Something went wrong. Please try again or write to info@pulaar.co.",
    cities: "Dakar · Paris",
    instagram: "Instagram",
    asideTitle: "The atelier replies.",
    asideText: "We read every message and answer within 48 hours.",
  },

  specialOrder: {
    title: "Notify me",
    subtitle: "Leave us your details — we'll write the moment this piece becomes available.",
    name: "Name",
    email: "Email",
    phone: "Phone (optional)",
    message: "Message (optional)",
    submit: "Sign me up",
    sending: "Sending…",
    sent: "Noted. We'll get back to you.",
    close: "Close",
  },

  archives: {
    eyebrow: "— Archives",
    titleA: "Stories, ",
    titleEm: "inspirations,",
    titleC: " archives.",
    seeAll: "All chapters",
    intro: "Maabube, Dammeel, Ceddo. Three figures, three gestures, three ways of inhabiting history. Pulaar does not build a wardrobe alone: the house composes chapters, materials, images and objects in slow circulation.",
    chapter: "Chapter · {{symbol}}",
    readStory: "Read the story",
    explore: "Explore this chapter",
    atelierEyebrow: "— Atelier",
    atelierTitleA: "Hand, ",
    atelierTitleEm: "matter",
    atelierTitleC: ", time.",
    atelierBadge: "— Atelier · Gesture",
    citiesBadge: "Dakar · Paris",
    troisFiguresEyebrow: "— Three figures",
    troisFiguresTitle: "Maabube. Dammeel. Ceddo.",
    troisFiguresIntro: "Three Fula figures — the artisan who transmits, the noble who carries, the warrior who walks. Three ways of inhabiting the world. Three chapters.",
    blocks: {
      matieres: {
        title: "Materials",
        text: "Woven cottons, vintage canvases, wools, leathers and fabrics chosen for their hand, their hold, their ability to age with dignity.",
      },
      "savoir-faire": {
        title: "Craft",
        text: "A dialogue between weaving, pattern-making, cut and finish. Every detail keeps the trace of the gesture.",
      },
      "petites-series": {
        title: "Small series",
        text: "Only a few pieces per model. Rarity comes not from effect, but from the time each piece requires.",
      },
      commande: {
        title: "Made to order",
        text: "Some pieces may be made to order after exchange with the atelier, depending on available materials.",
      },
      fabrication: {
        title: "Manufacturing",
        text: "Confected between Dakar and Paris. Two ateliers, one same demand: the lasting presence of the garment.",
      },
    },
    transmissionEyebrow: "— Transmission",
    transmissionTitleA: "Numbered, signed, ",
    transmissionTitleEm: "repairable",
    transmissionTitleC: ".",
    transmissionText: "Each piece bears a trace: a number, a hand, a story. With time it can be altered, adjusted or repaired. Pulaar prefers continuity to replacement.",
    transmissionCta: "Talk to the atelier",
  },

  apropos: {
    eyebrow: "— About",
    titleA: "",
    titleEm: "Pulaar",
    titleC: ".",
    s1Label: "01 — Pulaar",
    s1p1: "Pulaar is a contemporary wardrobe born between Paris and Dakar.",
    s1p2: "The house draws on the history, cultures and craftsmanship of West Africa to build its own language of clothing.",
    s1p3: "Each piece is conceived as an interpretation rather than a reproduction: a fabric, a cut, a detail or a gesture may carry the trace of a history without ever seeking to reconstruct it.",
    s2Label: "02 — The name",
    s2p1: "Pulaar is the name of a language spoken by the Haalpulaar, communities historically present across several territories of West Africa.",
    s2p2: "The name naturally carries notions of movement, territory and transmission.",
    s2p3: "Pulaar begins in Senegal, but its gaze extends beyond contemporary borders.",
    s3Label: "03 — The wardrobe",
    s3p1: "Pulaar does not think of its garments as collections destined to disappear with the seasons.",
    s3p2: "Silhouettes are developed to last, return and evolve. The same piece may reappear in another fabric, be produced in small quantities or made according to the availability of a cloth.",
    phraseA: "The garment remains.",
    phraseB: "The fabric may change.",
    blocks: {
      matieres: {
        title: "Materials",
        text: "Woven cottons, denim, vintage canvas and fabrics selected for their texture, their hold and the way they evolve over time.",
      },
      fabrication: {
        title: "Making",
        text: "Developed and made between Paris and Dakar, with workshops and skills chosen according to the needs of each piece.",
      },
      rythme: {
        title: "Rhythm",
        text: "Produced in small runs or to order, certain pieces may return in new fabrics rather than being replaced by a new collection.",
      },
    },
  },

  transmissionPage: {
    eyebrow: "— Transmission",
    titleA: "Hands, ",
    titleEm: "gestures",
    titleC: ".",
    intro: "Behind every fabric, every gesture and every garment, there are people. Pulaar documents those whose skills take part in its story.",
  },

  home: {
    heroEyebrow: "— Pulaar · Season 01",
    heritage: "Heritage",
    heritageEm: "in motion.",
    troisEyebrow: "— Archives",
    troisTitleA: "Three ",
    troisTitleEm: "chapters",
    troisTitleC: ".",
    troisDesc: "Maabube, Dammeel, Ceddo. Three figures, three gestures, three ways of inhabiting history — not collections, but chapters.",
    vestiaireEyebrow: "— Wardrobe",
    vestiaireTitleA: "Pieces to ",
    vestiaireTitleEm: "order",
    vestiaireTitleC: ".",
    seeAll: "See the full wardrobe",
    chapter: "Chapter · {{symbol}}",
    explore: "Explore this chapter",
    atelierEyebrow: "— Atelier",
    atelierTaglineA: "Chosen materials, slow gestures, ",
    atelierTaglineEm: "small series",
    atelierTaglineC: ".",
    exploreArchives: "Explore the archives",
  },

  mondes: {
    maabube: {
      subtitle: "The hand that transmits.",
      teaser: "The Maabo preserves knowledge through the hand. Their craft transmits a living memory: the gesture, the weave, the matter that crosses time.",
      quote: "The Maabube's hammer strikes with wisdom, for each blow seals history and shapes the future.",
      storyTitle: "The Master Weaver: Demba Maabu",
      story: [
        "In the lands of Fouta lived Demba Maabu, a weaver with magical hands. The Maabube were sacred craftsmen, and their fabrics carried stories woven into the threads.",
        "Demba answered the king: \"Give me time, and I will offer you a cloth that speaks.\" For months, he worked in silence, talking to spirits and listening to the murmur of ancestors.",
        "When the cloth was finished, it shone like gold and carried the patterns of a people. \"My craft is not for sale. It comes from my ancestors, and it is for them that I weave,\" he said.",
        "The Maabube show us that craftsmanship is the soul of a civilisation.",
      ],
    },
    dammeel: {
      subtitle: "Bearing as inheritance.",
      teaser: "Dammeel evokes a nobility without display. A presence, a poise, a way of entering space. The garment becomes calm, authority and silent elegance.",
      quote: "A worthy leader is not only crowned — he carries the weight and wisdom of his people.",
      storyTitle: "The Humble King: Kumba Ndoffène Mbodj",
      story: [
        "In the heart of Kajoor, a Dammeel named Kumba Ndoffène Mbodj loved his people above all. Rather than stay in his palace, he walked through villages disguised as a simple traveller.",
        "A farmer said: \"How can the king understand our suffering when he does not know the sweat of work?\" Moved, Kumba returned to the fields and spent the day ploughing under the burning sun.",
        "When he revealed his identity, the farmer fell to his knees. \"A good king must feel the suffering of his people in order to serve them with justice,\" he said.",
        "The Dammeel remind us that a king's true greatness lies in his humility.",
      ],
    },
    ceddo: {
      subtitle: "The standing body.",
      teaser: "Ceddo carries the idea of resistance, of protection and movement. This chapter explores frank silhouettes: garments of passage, of road, of memory, of inner bearing.",
      quote: "The Ceddo holds his spear with pride, but it is courage that gives his weapon its true weight.",
      storyTitle: "The Warrior and His Destiny: Mbañik Ndongo",
      story: [
        "In the kingdom of Kajoor, a young Ceddo named Mbañik Ndongo was known for his courage and sense of honour. But Mbañik was different: he was not only strong, he had the mind of a strategist.",
        "When an enemy army threatened the kingdom, he rose: \"Give me your men, and I will protect our land as a lion protects its den.\" With a handful of warriors, he defeated the enemy through cunning.",
        "When the Dammeel died without an heir, the wise men said: \"This man, though not noble, has the heart of a king.\" Mbañik became Damel, the first Tiedo to wear the crown.",
        "The Ceddo teach us courage and sacrifice.",
      ],
    },
  },

  mondeDetail: {
    photoCredit: "Photography",
    daCredit: "Creative director",
    citationEyebrow: "— Fula proverb",
    storyEyebrow: "— Story",
    galleryEyebrow: "— Editorial gallery",
    backToArchives: "Back to archives",
    nextChapter: "Next chapter",
    prevChapter: "Previous chapter",
  },

  atelierBlocks: [
    {
      eyebrow: "— Gesture",
      title: "Weaving takes the time of the hand.",
      body: "Each weft is laid, checked, adjusted. No machine reproduces the attention a weaver brings to balancing a pattern. The work keeps the memory of the fingers that made it.",
    },
    {
      eyebrow: "— Matter",
      title: "Raw cotton, Japanese denim, true indigo.",
      body: "Pulaar selects fabrics for their weight, their grain, their ability to age with dignity. A piece must gain in presence, not lose it.",
    },
    {
      eyebrow: "— Time",
      title: "One piece, weeks of making.",
      body: "From sketch to shipping: drawing, prototyping, weaving, cutting, assembling, finishing. Each step bears a signature, each signature a name.",
    },
  ],
};

export default en;
